import angular from 'angular';
import delegatedCardRowComponent from './delegatedCardRow.component';

let delegatedCardRowModule = angular.module('delegatedCardRow', [])

.component('delegatedCardRow', delegatedCardRowComponent)

.name;

export default delegatedCardRowModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/delegatedCardRow.js